import React, { useState, useEffect } from 'react'
import I18n from 'i18n'
import { subscriptionTypes } from 'components/common/Constants'
import PremiumOverlay from '../../../../premium_membership/PremiumOverlay'
import TabPanel, { Tab } from '../../../../atomic/atoms/TabPanel'
import PhysicalComplaintsDashboard from '../complaints/PhysicalComplaintsDashboard'
import MultiAthleteQuestionnaireDashboard from '../multi_athlete/MultiAthleteQuestionnaireDashboard'
import TrainingOrWellbeingQuestionnaireDashboardOptimized from './TrainingOrWellbeingQuestionnaireDashboardOptimized'
import DashboardStateWrapper from 'components/analysis/dashboards/questionnaire/common/DashboardStateWrapperTS'
import { useLocation, useHistory } from 'react-router-dom'

const FullQuestionnaireDashboardComponent = (props) => {
  const location = useLocation()
  const history = useHistory()
  const [selectedTab, setSelectedTab] = useState('training')

  // Extract tab from URL hash on initial load or when hash changes
  useEffect(() => {
    const hash = location.hash.replace('#', '')
    if (hash) {
      setSelectedTab(hash)
      const tabElement = document.getElementById(hash)
      if (tabElement) {
        tabElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [location.hash])

  const handleTabChange = (tabId) => {
    setSelectedTab(tabId)
    const currentHash = location.hash.replace('#', '')
    let newHash = tabId

    if (tabId === 'welzijn' && currentHash.startsWith('welzijn-')) {
      newHash = currentHash
    }

    history.replace({ hash: `#${newHash}` })
  }

  return (
    <PremiumOverlay activeFor={[subscriptionTypes.coach, subscriptionTypes.researcher]} showBadge={false}>
      <TabPanel
        id='full-questionnaire-dashboard-tabs'
        onShow={handleTabChange}
      >
        <Tab id='training' title={I18n.t('components.dashboards.questionnaire.training.tab_title')}>
          {selectedTab === 'training' && <TrainingOrWellbeingQuestionnaireDashboardOptimized training {...props} />}
        </Tab>
        <Tab id='welzijn' title={I18n.t('components.dashboards.questionnaire.wellbeing.tab_title')}>
          {selectedTab === 'welzijn' && <TrainingOrWellbeingQuestionnaireDashboardOptimized wellbeing {...props} />}
        </Tab>
        <Tab id='lichamelijke_klachten' title={I18n.t('components.dashboards.questionnaire.physical_complaints.tab_title')}>
          {selectedTab === 'lichamelijke_klachten' && <PhysicalComplaintsDashboard {...props} premium />}
        </Tab>
        <Tab id='vergelijken' title={I18n.t('components.dashboards.questionnaire.compare.tab_title')}>
          {selectedTab === 'vergelijken' && <MultiAthleteQuestionnaireDashboard {...props} />}
        </Tab>
      </TabPanel>
    </PremiumOverlay>
  )
}

export default DashboardStateWrapper(FullQuestionnaireDashboardComponent)
